import PropTypes from "prop-types";
import React, { useState } from "react";
import { Pie } from "react-chartjs-2";
import NoChartData from "../Shared/NoChartData";

const PieChart = ({ data, sliceItems = true, sliceNumber = 4, title }) => {
  const keys = Object.keys(data);

  let finalKeys = [];
  let finalValues = [];
  // Sort keys by their corresponding values in descending order
  const sortedKeys = keys.sort((a, b) => data[b].int_value - data[a].int_value);
  if (sliceItems) {
    // Determine the top 5 keys and the rest as "Other"
    const topKeys = sortedKeys.slice(0, sliceNumber);
    const otherKeys = sortedKeys.slice(sliceNumber);

    // Calculate the "Other" value
    const otherValue = otherKeys.reduce(
      (acc, key) => acc + data[key].int_value,
      0
    );

    // Create the final keys and values arrays
    finalKeys = otherKeys.length > 0 ? [...topKeys, "Other"] : topKeys;
    finalValues =
      otherKeys.length > 0
        ? [...topKeys.map((key) => data[key].int_value), otherValue]
        : topKeys.map((key) => data[key].int_value);
  } else {
    finalKeys = sortedKeys;
    finalValues = sortedKeys.map((key) => data[key].int_value);
  }

  const [chartData, _setChartData] = useState({
    labels: finalKeys,
    datasets: [
      {
        label: "Users Gained",
        data: finalValues,
        backgroundColor: [
          "#EADFB4",
          "#9BB0C1",
          "#51829B",
          "#F6995C",
          "#F16B6F",
          "#FEF3E2",
          "#BEC6A0",
          "#708871",
          "#606676",
          "#9BB8CD",
          "#FFF7D4",
          "#EEC759",
          "#B1C381",
          "#F2D8D8",
          "#5C8984",
          "#545B77",
          "#374259",
        ],
        borderColor: "black",
        borderWidth: 1,
      },
    ],
  });

  const chartLabelFormatter = (value, context) => {
    const total = context.chart.data.datasets[0].data.reduce(
      (acc, val) => acc + val,
      0
    );
    const percentage = ((value / total) * 100).toFixed(2);
    return (
      context.chart.data.labels[context.dataIndex] + ": " + percentage + "%"
    );
  };

  console.log(data);

  if (
    !chartData ||
    Object.keys(data).length === 0 ||
    Object.values(data).every(
      (value) => (value || { int_value: 0 }).int_value === 0
    )
  ) {
    return <NoChartData />;
  }

  return (
    <div className="bg-white dark:bg-gray-800 px-9 pb-9 pt-4 rounded-lg w-full card-shadow">
      {title && (
        <h3 className="dark:text-white font-semibold text-center text-gray-900 mb-2">
          {title}
        </h3>
      )}
      {sortedKeys.map((key, index) => (
        <p
          className="flex px-2 py-1 rounded justify-between font-normal text-gray-700 dark:text-gray-400 dark:odd:bg-gray-700 odd:bg-gray-100"
          key={key}
        >
          <span>{key}:</span>
          <span>{data[key].formatted_value}</span>
        </p>
      ))}
      <Pie
        data={chartData}
        className="mt-4"
        options={{
          plugins: {
            datalabels: {
              color: "black",
              formatter: chartLabelFormatter,
              labels: {
                title: {
                  font: {
                    weight: "normal",
                    size: 16,
                  },
                },
              },
            },
          },
        }}
      />
    </div>
  );
};

PieChart.propTypes = {
  data: PropTypes.object.isRequired,
  sliceItems: PropTypes.bool,
  sliceNumber: PropTypes.number,
  title: PropTypes.string,
};

export default PieChart;
